/** Shared catalog-job display helpers (jobs tray + admin models surfaces).
 *
 *  Lifted from `SyncStatusChip` so the app-wide `JobsTray` and any per-model
 *  chips render job status identically. `TOTAL_PHASES` is FE-side knowledge:
 *  the backend reports `current_phase` but no phase total, so the tray maps
 *  each job type to its known phase count to draw a determinate Progress bar.
 */

import type { CatalogJobStatus } from '@/api/types';
import { CATALOG_JOB_TERMINAL } from '@/api/hooks/useJobPolling';

/** Terminal job states as a Set for O(1) checks. */
export const CATALOG_JOB_TERMINAL_SET = new Set<string>(CATALOG_JOB_TERMINAL);

/** FE-side phase totals per job type (backend exposes no total). */
export const TOTAL_PHASES: Record<string, number> = {
  catalog_generation: 4,
  metadata_enrichment: 2,
  eval_refresh: 2,
};

/** Badge variant for a generation/enrichment job status. */
export function jobStatusVariant(
  status: CatalogJobStatus | string,
): 'success' | 'warning' | 'destructive' | 'outline' {
  switch (status) {
    case 'completed':
      return 'success';
    case 'failed':
      return 'destructive';
    case 'expired':
    case 'cancelled':
      return 'warning';
    default:
      return 'outline';
  }
}
